
/**
 * Self-hosted CMS videos that have been mirrored to Bunny Stream (uploaded by
 * Steve 2026-08-19, library BUNNY_STREAM_LIBRARY_ID). Any video component that
 * would render one of these MP4s serves the adaptive Bunny embed instead —
 * phones stream a few hundred KB rather than downloading the full file. A new
 * upload with a different filename simply bypasses the map (mp4 fallback).
 */
const BUNNY_VIDEO_MAP: Record<string, string> = {
  'wilson-property.mp4': '66d38435-192e-4269-aa1a-460a0b77a836',
  'wilson-property-opt.mp4': '66d38435-192e-4269-aa1a-460a0b77a836',
  'careers-culture-video.mp4': 'd66d89d8-2043-4cf7-9e3d-4b40deb230c4',
  'wilson-property-footer.mp4': '79641989-736a-4c90-84b3-dbad48afb93e',
}

/**
 * Direct-play CDN host for the Wilson Bunny library. The pull zone blocks
 * referer-less requests (curl gets 403) but browsers always send one, so
 * <video src> works. Used for NON-autoplay videos so they can share the
 * careers-page click-to-play styling instead of Bunny's iframe chrome.
 */
const BUNNY_CDN_HOST = 'vz-d2636ff3-57a.b-cdn.net'

export function getBunnyMp4Url(guid: string, resolution: '720p' | '1080p' = '1080p'): string {
  return `https://${BUNNY_CDN_HOST}/${guid}/play_${resolution}.mp4`
}

export function getBunnyThumbnailUrl(guid: string): string {
  return `https://${BUNNY_CDN_HOST}/${guid}/thumbnail.jpg`
}

export function getBunnyGuidForFilename(filename?: string | null): string | null {
  if (!filename) return null
  return BUNNY_VIDEO_MAP[filename] ?? null
}
